// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root___kWeA","label":"SetPasswdForm_label__1k255"};